/**
 * Picks a candidate locale from the explicit `options.locale` or the browser's
 * `navigator.language`, lowercased to a 2-letter primary subtag. NO whitelist
 * filtering — the backend is authoritative.
 *
 * The widget sends this candidate as `X-Assilya-Locale` only on the FIRST
 * request (`/chatbot/config`). The server clamps to the company's enabled
 * locale list, returns `config.locale` (the resolved one), and the widget uses
 * that for every subsequent call. See `chatbot.js`.
 */
const FALLBACK_LOCALE = 'en';

export function pickCandidate(explicit) {
    if (typeof explicit === 'string' && explicit.length >= 2) {
        return explicit.slice(0, 2).toLowerCase();
    }

    const nav = (typeof navigator !== 'undefined' && navigator.language) || '';

    if (nav.length >= 2) {
        return nav.slice(0, 2).toLowerCase();
    }

    return FALLBACK_LOCALE;
}
